import { CustomerVariableHeaders, CustomerVariableModel } from "@/views/loyalty/models/customer_variable.model"

export class CustomerVariableService {
    constructor (data) {
        this.obj = data || CustomerVariableModel // || Object.create({}, CustomerVariableModel)
    }

    // attrObj is Array
    addAttributes (attrObj) {
        if (attrObj.length <= 0) return this
        this.obj.nickname = attrObj[0].name
        this.obj.attributeId = attrObj[0].attributeId
        return this
    }

    addCustomer (customerId) {
        this.obj.customerId = customerId
        return this
    }

    get deletedHuman () {
        const text = this.obj.deleted ? 'Да' : 'Нет'
        return { deletedHuman: text }
    }

    get item () {
        return Object.assign(this.obj, this.deletedHuman)
    }

    static getHeaders () {
        return CustomerVariableHeaders
    }

    toCsv (delimiter) {
        const delim = delimiter || ';'
        return this.obj.nickname + delim +
            this.obj.hint + delim +
            this.obj.order + delim +
            this.obj.deletedHuman + ';\n'
    }
}
